import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home/Home";
import OutletComponent from "../components/OutletComponent";
import Aboutus from "./Aboutus/Aboutus";
import Expertise from "./Expertise/Expertise";
import CaseStudies from "./CaseStudies/CaseStudies";
import Thinking from "./Thinking/Thinking";
import Contactus from "./Contactus/Contactus";
import ScrollToTop from "../components/Scroll/ScrollToTop";
import CaseStudyDetail from "./CaseStudyDetail/CaseStudyDetail";
import ThinkingDetailPage from "./ThinkingDetailPage/ThinkingDetailPage";
import Whatwedo from "./WhatwedoAboutus/Whatwedo";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";

import Whatwedo2 from "./Whatwedo2/Whatwedo2";
import Whatwedo3 from "./Whatwedo3/Whatwedo3";
import Whatwedo4 from "./Whatwedo4/Whatwedo4";
import Whatwedo5 from "./Whatwedo5/Whatwedo5";
import CaseStudyDetailContent from "./CaseStudyDetail/CaseStudyDetailContent";
import Events from "./Events/Events.jsx";
import EventDetails from "./Events/EventsDetails.jsx";
const Pages = () => {
  return (
    <>
      <Router>
        <ScrollToTop /> {/* Add the ScrollToTop component */}
        <Routes>
          <Route element={<OutletComponent />}>
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<Aboutus />} />
            <Route path="/solutions" element={<Expertise />} />
            <Route path="/casestudies" element={<CaseStudies />} />
            <Route path="/casestudydetail" element={<CaseStudyDetail />} />
            <Route
              path="/thinkingdetailpage"
              element={<ThinkingDetailPage />}
            />
            <Route path="/whatwedo" element={<Whatwedo />} />
            <Route path="/whatwedo2" element={<Whatwedo2 />} />
            <Route path="/whatwedo3" element={<Whatwedo3 />} />
            <Route path="/whatwedo4" element={<Whatwedo4 />} />
            <Route path="/whatwedo5" element={<Whatwedo5 />} />
            <Route path="/thinking" element={<Thinking />} />
            <Route path="/contactus" element={<Contactus />} />
            <Route
              path="/casestudydetails/:id"
              element={<CaseStudyDetailContent />}
            />
            <Route path="/casestudydetail1" element={<ThinkingDetailPage />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetails />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default Pages;
